import { useDispatch, useSelector } from 'react-redux';
import { Form, Card } from '@deere/ux.uxframe-react';
import { FUTURE_CONSIDERATIONS_SECTION_INDIRECT, EMPTY_BODY } from '../../utils/surveyLiterals'
import { updateSurveyAnswers } from '../../redux/action/surveyAction';
import { findAnswerIndex, getTranslation } from '../../utils/utils';
import React, { useState, useEffect } from 'react';
import store from '../../redux/store'
import {DebounceInput} from 'react-debounce-input';
import RadioGroup from '../../components/RadioGroup';

export default function FutureConsideration({ survey }) {

    const dispatch = useDispatch()
    const [answers, setAnswers] = useState([]);
    const [checkSection] = useState(false);
    const surveyResponse = useSelector(state => state.survey.surveyResponse);
    useEffect(() => {
        setAnswers([...store.getState().survey.surveyAnswers])
    }, [surveyResponse])

    if (!survey) return EMPTY_BODY;


    const additionalComments = survey.sections.find(e => e.description.toUpperCase() === FUTURE_CONSIDERATIONS_SECTION_INDIRECT.toUpperCase() && e.active);
    const questions = additionalComments.questions.sort((a, b) => (a.showOrder > b.showOrder) ? 1 : -1);

    const updateAnswer = (e, questionId) => {
        dispatch(updateSurveyAnswers({ questionId: questionId, answer: e.target ? e.target.value : e }));
        setAnswers([...store.getState().survey.surveyAnswers])
    }

    function createTextArea(qu) {
        let index = findAnswerIndex(qu.id, answers);
        return <Form.Group key={qu.id}>
            <Form.Label className="uxf-label">{getTranslation(qu, 'text')}</Form.Label>
            <div>
                <DebounceInput
                        element="textarea" rows="2" aria-describedby="textarea-text" className="form-control" debounceTimeout={300}
                        onChange={e => updateAnswer(e, qu.id)} value={index >= 0 ? answers[index].answer : '' }/>
            </div>
        </Form.Group>
    }

    const createOption = ( question ) => {
        let display = true;
        if(question.idQuestionDepends) {
            let qIndex = findAnswerIndex(question.idQuestionDepends, answers);
            display = qIndex >= 0 && answers[qIndex].answer === question.idSelectionDependson.toString();
        }

        if( display ) {
            return <Form.Row className="d-block mb-4" key={question.id}>
                <Form.Group key={question.id}>
                    <Form.Label className="uxf-label">{getTranslation(question, 'text')}</Form.Label>
                        <div><RadioGroup key={question.id} rgIndex={4} radioLabels={question ? question.selections : []}
                            updateAnswer={updateAnswer} question={question}
                            defaultValue={findAnswerIndex(question.id, answers) >= 0 ? answers[findAnswerIndex(question.id, answers)].answer : ''} 
                            section={getTranslation(additionalComments, 'description')}
                            checkedProprietary={checkSection}/></div>
                    </Form.Group>
                </Form.Row>
        }
    }

    return (<Card key={additionalComments.id}>
        <Card.Body id={additionalComments ? additionalComments.description : ''}>
            <Card.Title className='pb-3 font-weight-bold'>
                {getTranslation(additionalComments, 'description')}

            </Card.Title>
            <>
                {
                    questions.map((q) => {
                        if(q.type === 'OPEN') {
                            return createTextArea(q)
                        }

                        if(q.type === 'OPTION') {
                           return createOption(q)
                        }
                        return <></>;
                    })
                }
            </>
        </Card.Body>
    </Card>)
}
